var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubContractorLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,14.8c0.1-0.3,0-1,0.1-1.3c-1.2,0.5-2.7,0.6-4,0v0.8C9.6,16.6,12.8,17,13.4,14.8z M15.9,5.2 c-0.2-1.5-1-2.9-2.4-3.6v1.1c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0-1.3,0-1.4c-0.1-0.5-0.6-1-1.2-1 c-0.6,0-1.1,0.4-1.2,1c0,0.1,0,1.3,0,1.4c0,0.5-0.8,0.5-0.8,0V1.7C8.2,2.3,7.3,3.7,7.1,5.2C6.7,5.4,6.3,5.8,6.3,6.3 c0,0.7,0.6,1.2,1.2,1.2h7.9C16.8,7.5,17.1,5.7,15.9,5.2z M9.5,12.6c2.7,1.5,5.9-0.4,6.2-3.5l0.1-0.8c-0.3,0.1-8.3,0.1-8.6,0 l0.1,0.8C7.5,10.6,8.2,11.9,9.5,12.6z M2.4,18.1v4.1c0,0.2,0.2,0.4,0.4,0.4h2.8v-7.8L4.9,15C3.4,15.3,2.4,16.6,2.4,18.1z M18.1,15 l-0.7-0.2v7.8h2.8c0.2,0,0.4-0.2,0.4-0.4v-4.1C20.6,16.6,19.6,15.3,18.1,15L18.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,15c-0.1-0.2-0.1-0.5-0.1-0.8l-2.4,0.5v8h4.8V17C10,16.9,9,16,8.8,15z M9.9,19c0,0.2-0.2,0.4-0.4,0.4H7.9 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h1.6C9.7,18.6,9.9,18.8,9.9,19z M14.3,14.3c0,1.4-1,2.6-2.4,2.7v5.6h4.8v-8l-2.4-0.5 V14.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubContractorLeft);
export default __webpack_public_path__ + "static/media/sub-contractor-left.33626f7b546e5950c628c61c81a64ca9.svg";
export { ForwardRef as ReactComponent };